import { AdPlacement } from "@/components/ads/AdPlacement";
import { FinanceCalc } from "../components/FinanceCalc";
import { SipBreadcrumb } from "../components/SipBreadcrumb";
import { SipExplainer } from "../components/SipExplainer";
import { SipRelated } from "../components/SipRelated";
import type { FinanceCalcDef } from "../lib/calculators";

/** Generic page for any investment calculator, rendered from its config. */
export function CalculatorPage({ def }: { def: FinanceCalcDef }) {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <SipBreadcrumb current={def.navName()} />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {def.h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {def.intro()}
          </p>
        </header>

        <FinanceCalc config={def.config} />

        <SipExplainer
          howTo={def.howTo()}
          faqs={def.faqs.map((f) => ({ q: f.q(), a: f.a() }))}
        />

        <AdPlacement className="mt-10" />

        <SipRelated currentSlug={def.slug} />
      </div>
    </div>
  );
}
